// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-icon{box-sizing:border-box;display:inline-block;margin:0;padding:0;vertical-align:middle;line-height:1em}.bw-icon svg{fill:currentColor;height:100%;stroke:none;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
